import React from "react";

interface FeedbackCellProps {
  feedback: string;
}

export const FeedbackCell: React.FC<FeedbackCellProps> = ({ feedback }) => {
  return <span>&ldquo;{feedback}&rdquo;</span>;
};
